import { useEffect, useState, useRef } from "react";

/**
 * Hook para avanzar automáticamente un slider cuando entra en la vista.
 * @param {Object} sliderRef - Referencia del slider (useRef).
 * @param {number} intervalTime - Tiempo en milisegundos para avanzar (default 60s).
 */
const useAutoSlideOnView = (sliderRef, intervalTime = 60000) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.6 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Asegurarnos de que sliderRef.current está listo antes de ejecutar slickNext()
      setTimeout(() => {
        if (sliderRef.current && sliderRef.current.slickNext) {
          sliderRef.current.slickNext();
        }

        intervalRef.current = setInterval(() => {
          if (sliderRef.current && sliderRef.current.slickNext) {
            sliderRef.current.slickNext();
          }
        }, intervalTime);
      }, 500); // Esperamos 500ms para asegurar que el slider se haya montado
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isVisible, sliderRef, intervalTime]);

  return sectionRef;
};

export default useAutoSlideOnView;
